import { core } from '@tock/coretypes';
import protos from 'utils/protos';

const { DisplayColor } = protos;

/**
 * Map of DisplayColor enum values to hex values
 */

export const displayColorValueMap: {
  [K in core.DisplayColor]: string;
} = {
  COLOR_1: 'var(--spec-experience-avocado, #14b8a6)',
  COLOR_2: 'var(--spec-experience-dill, #84cc16)',
  COLOR_3: 'var(--spec-experience-lime, #d9f99d)',
  COLOR_4: 'var(--spec-experience-sherbet, #f97316)',
  COLOR_5: 'var(--spec-experience-orange, #f59e0b)',
  COLOR_6: 'var(--spec-experience-peach, #fed7aa)',
  COLOR_7: 'var(--spec-experience-mint, #99f6e4)',
  COLOR_8: 'var(--spec-experience-blueberry, #bfdbfe)',
  COLOR_9: 'var(--spec-experience-grape, #a855f7)',
  COLOR_10: 'var(--spec-experience-taro, #e9d5ff)',
  COLOR_11: 'var(--spec-experience-raspberry, #ec4899)',
  COLOR_12: 'var(--spec-experience-strawberry, #fbcfe8)',
};

/**
 * Map of DisplayColor enum values to display names
 */
export const displayColorNameMap: {
  [K in core.DisplayColor]: string;
} = {
  COLOR_1: 'Avocado',
  COLOR_2: 'Dill',
  COLOR_3: 'Lime',
  COLOR_4: 'Sherbet',
  COLOR_5: 'Orange',
  COLOR_6: 'Peach',
  COLOR_7: 'Mint',
  COLOR_8: 'Blueberry',
  COLOR_9: 'Grape',
  COLOR_10: 'Taro',
  COLOR_11: 'Raspberry',
  COLOR_12: 'Strawberry',
};

/**
 * Type guard to ensure value is a valid DisplayColor
 */
export const isValidDisplayColor = (value: string): value is core.DisplayColor =>
  Object.keys(DisplayColor).includes(value);

/**
 * Array of all DisplayColor enum values
 */
export const allDisplayColors = Object.keys(DisplayColor) as core.DisplayColor[];

/**
 * Gets the value stored at ticketType.ticketTypeDetails.displayColor
 */
export const getDisplayColorValueFromTicketType = (ticketType: core.TicketType) => {
  if (!ticketType?.ticketTypeDetails?.displayColor) {
    return displayColorValueMap['COLOR_1'];
  }
  return displayColorValueMap[ticketType.ticketTypeDetails.displayColor];
};

/**
 * Gets a random display color value
 */
export const getRandomDisplayColorForInitialValue = () => {
  return allDisplayColors[Math.floor(Math.random() * allDisplayColors.length)];
};
